import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch, create, update } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      affiliate: {}
    },
    pagination: {}
  },

  getters: {
    currentAffiliates: (state) => state.list,
    currentAffiliate: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    affiliateFetched(state, { affiliate }) {
      state.item = affiliate
    },

    affiliatesFetched(state, { affiliates }) {
      state.list = affiliates
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchAffiliates({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/affiliates',
        params: {
          page,
          ...buildFilters(filters)
        }
      })
      const affiliates = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('affiliatesFetched', { affiliates })
      commit('paginationFetched', { pagination })
    },

    async fetchAffiliate({ commit }, params) {
      const response = await fetch({ url: `/api/admin/accounts/${params.accountId}/affiliates/${params.id}` })
      const affiliate = await deserialize(response.data)

      commit('affiliateFetched', { affiliate })
    },

    async createAffiliate({ commit, state, dispatch }, data) {
      const response = await create({
        url: `/api/admin/accounts/${data.accountId}/affiliates`,
        type: 'affiliate',
        data,
        record: state.item
      })

      const affiliate = await deserialize(response.data)

      commit('affiliateFetched', { affiliate })

      return affiliate
    },

    async updateAffiliate({ commit, state, dispatch }, changes) {
      const response = await update({
        url: `/api/admin/accounts/${state.item.accountId}/affiliates/${state.item.id}`,
        patch: true,
        type: 'affiliate',
        changes,
        record: state.item
      })

      const affiliate = await deserialize(response.data)

      commit('affiliateFetched', { affiliate })
    }
  }
}
